import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Link } from 'react-router-dom';
import { apiClient } from '../../../shared/services/apiClient';
import './login.css';

const schema = z.object({ email: z.string().email('Enter a valid email') });
type FormData = z.infer<typeof schema>;

export const ForgotPasswordPage: React.FC = () => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormData>({
        resolver: zodResolver(schema),
    });

    const onSubmit = async (data: FormData) => {
        setError('');
        try {
            const res = await apiClient.post('/auth/forgot-password', data);
            setMessage((res.data as { message: string }).message);
        } catch (err: any) {
            setError(err.response?.data?.message ?? 'Something went wrong.');
        }
    };

    return (
        <>
            <div className="login-wrapper">
                <div className="login-card">
                    <div className="login-header">
                        <h1>Forgot Password</h1>
                        <p>Enter your email to receive a reset link</p>
                    </div>

                    {message && <div style={{ background: '#f0fdf4', border: '1px solid #86efac', color: '#375623', padding: '10px 14px', borderRadius: 8, marginBottom: 20, textAlign: 'center', fontSize: '0.9rem' }}>{message}</div>}
                    {error && <div className="login-error">{error}</div>}

                    {!message && (
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="form-group">
                                <label>Email Address</label>
                                <input type="email" {...register('email')} placeholder="you@example.com" />
                                {errors.email && <span className="field-error">{errors.email.message}</span>}
                            </div>
                            <button type="submit" className="login-btn" disabled={isSubmitting}>
                                {isSubmitting ? 'Sending…' : 'Send Reset Link'}
                            </button>
                        </form>
                    )}

                    <div className="login-footer">
                        <p><Link to="/login">Back to Login</Link></p>
                    </div>
                </div>
            </div>
        </>
    );
};
